import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const BackButton = ({ onClick }) => (
    <button className="back-button" onClick={onClick}/>
);

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/BackButton/index.js